export default __webpack_public_path__ + "media/Outlook.4992e.png";